import * as THREE from "three";

//// MODULES
import { createLights } from "./lights.js";
import { createCamera } from "./camera.js";
import { loadAssets } from "./assetsLoader.js";
import { updatePerlinBlob } from "./perlinBlob.js";
import { animateUVMap } from "./modelLoader.js";

//// ---- ////
//// INIT ////
//// ---- ////
let renderer, scene, camera;
let mouse = new THREE.Vector2();
let raycaster = new THREE.Raycaster();
let intersects = [];
let mouseMoved = false;

function init() {
  // Initialize the renderer
  renderer = new THREE.WebGLRenderer({ antialias: true, alpha: false });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.setClearColor(0x000000, 1);
  renderer.outputColorSpace = THREE.LinearSRGBColorSpace;

  const canvas = document.getElementById("three-canvas");
  canvas.appendChild(renderer.domElement);

  // Initialize the scene
  scene = new THREE.Scene();

  // Initialize the lights
  createLights(scene);

  // Initialize the camera
  camera = createCamera();
  camera.lookAt(new THREE.Vector3(0, 0, 0));

  // Add mouse event listeners
  window.addEventListener("mousemove", onMouseMove, false);
  window.addEventListener("resize", debounce(onWindowResize, 200), false);
}

// Handle mouse movement
function onMouseMove(event) {
  mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
  mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
  mouseMoved = true; // Set the flag to true when the mouse is moved
}

// Handle window resize
function debounce(func, wait) {
  let timeout;
  return function () {
    const context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
}

// Render the scene
function animate() {
  requestAnimationFrame(animate);

  // Update raycaster with the mouse position
  if (mouseMoved) {
    raycaster.setFromCamera(mouse, camera);
    intersects = raycaster.intersectObject(scene, true);
  }

  updatePerlinBlob(intersects);
  animateUVMap({
    scene: scene,
    speedUV: 0.00025,
  });
  renderer.render(scene, camera);
}

// Function to remove the loader
function removeLoader() {
  const bLoader = document.querySelector("#bubble-loader");
  bLoader.classList.remove("is-loading");
  const bCanvas = document.querySelector("#three-canvas");
  bCanvas.classList.add("is-loaded");
}

window.addEventListener("load", () => {
  init();
  loadAssets(renderer, scene, () => {
    requestAnimationFrame(() => {
      animate();

      removeLoader();
    });
  });
});
